import React from 'react';
import OwlCarousel2 from 'react-owl-carousel2';
import { NavLink } from 'react-router-dom';

const owloptions = {
    loop: true,
    margin: 10,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    items: 3,
    slideBy: 1,
    responsive: {
        0: {
            items: 1,
            slideBy: 1,
            autoplayTimeout: 5000
        },
        900: {
            items: 3
        },
        1000: {
            items: 3
        }
    }
};

class FeatureSlider extends React.Component {
	render() {
        return (
            <div className="fullwidth dark">
                <div className="row">
                    <div className="twelve columns">
                        <OwlCarousel2 options={owloptions}>
                            <div className="item">
                                <h5>AMD SEV Memory Encryption</h5>
                                <hr className="grey"/>
                                <div className="left paddingright"><i className="fa fa-shield-alt fa-5x" aria-hidden="true"></i></div>
                                <p>Hardware-enforced isolation encrypts each VM's memory with unique keys. The host cannot access your workload - even with physical access to the server.</p>
                            </div>
                            <div className="item">
                                <h5>Always-On Disk Encryption</h5>
                                <hr className="grey"/>
                                <div className="left paddingright"><i className="fa fa-lock fa-5x" aria-hidden="true"></i></div>
                                <p>AES-256 encryption enabled by default. Your data is protected at rest and in transit with no configuration required.</p>
                            </div>
                            <div className="item">
                                <h5>User-Controlled Decryption</h5>
                                <hr className="grey"/>
                                <div className="left paddingright"><i className="fa fa-key fa-5x" aria-hidden="true"></i></div>
                                <p>Industry-first control panel for managing encryption keys. Decrypt your server on reboot without console access - only you control the keys.</p>
                            </div>
                            <div className="item">
                                <h5>NVMe + 10 GbE Performance</h5>
                                <hr className="grey"/>
                                <div className="left paddingright"><i className="fa fa-tachometer-alt fa-5x" aria-hidden="true"></i></div>
                                <p>Up to ~90K read IOPS and ~38K write IOPS with sub-millisecond latency on NVMe storage. Dedicated 10 Gigabit Ethernet with no oversubscription.</p>
                            </div>
                            <div className="item">
                                <h5>Swiss Data Protection</h5>
                                <hr className="grey"/>
                                <div className="left paddingright"><i className="fa fa-map-marker-alt fa-5x" aria-hidden="true"></i></div>
                                <p>ISO 27001 certified facilities in Switzerland. Strong privacy laws, political neutrality, and 99.99% uptime SLA. Combined with <NavLink to="/en/data-protection-switzerland">Swiss data protection</NavLink> laws for exceptional data sovereignty.</p>
                            </div>
                            <div className="item">
                                <h5>Zero-Trust Architecture</h5>
                                <hr className="grey"/>
                                <div className="left paddingright"><i className="fa fa-user-shield fa-5x" aria-hidden="true"></i></div>
                                <p>You don't have to trust the hosting provider, the hypervisor, or other tenants. The hardware guarantees your data stays encrypted and isolated - it's mathematically impossible for anyone else to access it.</p>
                            </div>
                        </OwlCarousel2>
                    </div>
                </div>
            </div>
        )
    }
}

export default FeatureSlider;
